<template>
    <div class="popup" :class="{active: show}">
        <div class="in">
            <div class="btn_close" @click="$emit('close')"></div>
            <div class="title">Copy the URL</div>
            <input type="text" ref="link" :value="appPath" readonly/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: "shareToLink",
    props: ['show'],
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['appPath']),
    },
    components: {
        
    },
    mounted() {},
    watch: {
        show(val){
            if(val){
                this.$nextTick(()=>{
                    let self = this;
                    setTimeout(()=>{
                        self.$refs.link.focus();
                        self.$refs.link.select();
                    }, 200)
                })
            }
        }
    },
    methods: {},
    destroyed() {},
};
</script>

<style scoped lang="scss">
.popup{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000, $alpha: 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s, visibility .3s;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .in{
        width: 5.3rem;
        border-radius: .1rem;
        background: #fff;
        position: relative;
        padding: .4rem .55rem;
        .btn_close{
            width: .4rem;
            height: .4rem;
            border-radius: 50%;
            background: rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            top: 0;
            right: -0.5rem;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .title{
            font-size: .26rem;
            text-align: center;
            font-weight: bold;
            margin-bottom: .4rem;
        }
        .prompt{
            font-size: .14rem;
            text-align: right;
        }
        textarea,
        input{
            width: 100%;
            margin-bottom: .5rem;
            font-size: .18rem;
            &::placeholder{
                color: #b2b2b2;
            }
        }
        input{
            height: .6rem;
            border: .02rem solid #b22526;
            border-radius: .05rem;
            padding: 0 .3rem;
        }
        textarea{
            height: 1.2rem;
            border-radius: .05rem;
            border: 1px solid #b2b2b2;
            resize: none;
            padding: .1rem;
        }
        .btn{
            height: .5rem;
            background: #b22526;
            font-size: .18rem;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: .05rem;
            cursor: pointer;
        }
    }
}
</style>